// extracted by mini-css-extract-plugin
module.exports = {"title":"style__title__7yxLd","wrapper":"style__wrapper__fXJCP"};